import type { IconData } from '@stacksjs/iconify-core'

export const foodDrinkCoffeeCup: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.91 10.67H6.1V7.62H4.57v4.57H6.1v9.14h1.52v6.1h1.53v-1.52h13.71v1.52h1.52v-6.1h1.53v-9.14h1.52V7.62h-1.52Zm-3.05 13.71H9.15v-1.52h13.71Zm0-4.57h-1.52v1.52h-1.53v-1.52h-1.52v1.52h-1.53v-1.52h-1.52v1.52h-1.52v-1.52h-1.53v1.52h-1.52v-1.52H9.15v-1.52h1.52v1.52h1.52v-1.52h1.53v1.52h1.52v-1.52h1.52v1.52h1.53v-1.52h1.52v1.52h1.53v-1.52h1.52Zm1.52-3.05H7.62v-1.52h16.76Zm0-3.04H7.62v-1.53h16.76ZM19.81 0h4.57v1.52h-4.57Zm1.53 30.48H10.67v-3.05H9.15V32h13.71v-4.57h-1.52zM18.29 1.52h1.52v1.53h-1.52ZM7.62 3.05h10.67v1.52H7.62Z\"/><path fill=\"currentColor\" d=\"M25.91 7.62v-6.1h-1.53V6.1H7.62V4.57H6.1v3.05z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default foodDrinkCoffeeCup
